import DetailsActionTypes from "./DetailsActionTypes.js";
class DetailsActions {
  fetchStatusAction(queryType, payload) {
    return {
      type: DetailsActionTypes.FETCH_STATUS,
      payload,
      queryType
    };
  }
  fetchFeatureStatusAction(queryType, payload) {
    return {
      type: DetailsActionTypes.FETCH_FEATURE_STATUS,
      payload,
      queryType
    };
  }
  updateStatusData(payload) {
    return {
      type: DetailsActionTypes.UPDATE_STATUS_DATA,
      payload
    };
  }
  updateFeatureStatusData(payload) {
    return {
      type: DetailsActionTypes.UPDATE_FEATURE_STATUS_DATA,
      payload
    };
  }
}
const DetailsActions$1 = new DetailsActions();
export {
  DetailsActions,
  DetailsActions$1 as default
};
//# sourceMappingURL=DetailsActions.js.map
